var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"box":_vm.box_init,"step":_vm.step}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }